import { render, staticRenderFns } from "./CmsTeaser.vue?vue&type=template&id=4264ebf2&scoped=true"
import script from "./CmsTeaser.vue?vue&type=script&lang=js"
export * from "./CmsTeaser.vue?vue&type=script&lang=js"
import style0 from "./CmsTeaser.vue?vue&type=style&index=0&id=4264ebf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4264ebf2",
  null
  
)

export default component.exports